export const MerchantTypes = {
    store: "store",
    warehouse: "warehouse"
};

export const isValidMerchantType = (merchantType) =>
    Object.values(MerchantTypes).includes(merchantType);
